<template>
  <div id="member" class="exchange_wrap">
    <div class="page_top">
      <div class="top_left">
        <img class="user_head" :src="userInfo.portrait ? userInfo.portrait : df_avatar" alt="">
        <div class="user_info">
          <div class="user_name">{{ userInfo.nickname }}</div>
          <div class="user_id">ID：{{ userInfo.uid }}</div>
        </div>
      </div>
      <div class="top_right">
        <div>当前身份：<span class="identify">{{ userInfo.vip_name }}</span></div>
        <div>有效期：{{ userInfo.vip_end_date }}</div>
      </div>
    </div>
    <div class="page_content">
      <!-- <div @click="paySuccess">模拟成功</div> -->
      <div class="vip_list" v-if="vipList.length <= 3">
        <div @click="chooseSetMeal(vip)" :class="['vip_item', { 'active': selectedVip.vip_type == vip.vip_type }]"
          v-for="(vip, index) in vipList" :key="vip.id">
          <div class="vip_icon"><img class="icon_img" :src="'/static/img/vip_' + (index + 1) + '.png'" alt=""></div>
          <div class="vip_name">{{ vip.name }}</div>
          <!-- <div class="vip_price" v-if="vip.vip_type==3&&selectedVip.vip_type ==3">{{ coupon_show?show_money:vip.show_money }}元/{{ vip.unit }}</div> -->
          <div class="vip_price">{{ vip.raw_money }}元/{{ vip.unit }}</div>
          <div class="vip_desc"><span class="origin_price">{{ vip.raw_money }}元</span>，{{ vip.tip2 }}</div>
        </div>
      </div>
      <div class="vip_list2">
        <div class="list_type1" :class="selectedVip.vip_type == vip.vip_type ? 'active' : ''" @click="chooseSetMeal(vip)"
          v-for="vip in vipList.slice(3, 4)" :key="vip.id">
          <div class="hot">
            <!--            超80%用户选择-->
            <span>
              超80%用户选择
            </span>
          </div>
          <div class="icon">
            <div class="vip_icon">
              <img src="/static/img/vip_3.png" class="icon_img" />
            </div>
            <div class="vip_name">{{ vip.name }}</div>
          </div>
          <div class="price_area">
            <p class="price">￥<span class="strong">{{ vip.raw_money }}</span><span class="throo">{{ vip.tip2 }}元</span>
            </p>
            <p class="desc">电脑+移动+微信永久使用</p>
          </div>
        </div>
      </div>
      <div class="vip_list3">
        <div @click="chooseSetMeal(vip)" :class="['vip_item', { 'active': selectedVip.vip_type == vip.vip_type }]"
          v-for="(vip, index) in vipList.slice(0, 3)" :key="vip.id">
          <div class="vip_icon"><img class="icon_img" :src="'/static/img/vip_' + (index) + '.png'" alt=""></div>
          <div class="vip_name">{{ vip.name }}</div>
          <div class="vip_price"><span class="small">￥</span>{{ vip.raw_money }}</div>
          <div class="vip_desc">{{ vip.tip2 }}</div>
        </div>
      </div>
      <!-- <div class="pay_type">
        <div class="pay_item ali_pay" v-if="!isWxEnv" :class="{'selected':pay_flat==2}" @click="pay_flat=2"><img class="pay_type_icon"
                                                                                                 src="./img/img_icon_82.png"
                                                                                                 alt="">支付宝支付<img
            class="select_icon" src="./img/img_icon_84.png" alt=""></div>
        <div class="pay_item wx_pay" v-if="isWxEnv" :class="{'selected':pay_flat==1}" @click="pay_flat=1"><img class="pay_type_icon"
                                                                                                src="./img/img_icon_83.png"
                                                                                                alt="">微信支付<img
            class="select_icon" src="./img/img_icon_85.png" alt=""></div>
      </div> -->

      <div class="pay_type">
        <div class="pay_item ali_pay" :class="{ 'selected': pay_flat == 2 }" @click="changePayType(2)" v-if="!isWxEnv">
          <div class="pay_sel_top">
            <img class="pay_sel_top_img" src="./img/payBaoT.png" />
            <div class="pay_sel_top_text">随机优惠1-3元</div>
          </div>
          <img class="pay_type_icon" src="./img/img_icon_82.png" alt="">支付宝支付<img class="select_icon"
            src="./img/img_icon_84.png" alt="">
        </div><!-- v-if="isWxEnv" -->
        <!--        <div class="pay_item wx_pay" :class="{ 'selected': pay_flat == 1 }" @click="changePayType(1)" v-if="isWxEnv">-->
        <div class="pay_item wx_pay" :class="{ 'selected': pay_flat == 1 }" @click="changePayType(1)">
          <!-- <div class="pay_sel_top">
                        <img class="pay_sel_top_img" src="./img/payWeiT.png" />
                        <div class="pay_sel_top_text">{{isWxEnv? `再优惠${coupon_money}元`:'原价无优惠' }}</div>
                    </div> -->
          <img class="pay_type_icon" src="./img/img_icon_83.png" alt="">微信支付<img class="select_icon"
            src="./img/img_icon_85.png" alt="">
        </div>


      </div>
      <div class="tips_desc_title">VIP会员解锁权益</div>
      <div class="vip_desc_qy">
        <p v-for="item in selectedVip.privilege" v-html="item"></p>
      </div>
      <div class="tips_desc_title">百万用户选择 · 评价</div>
      <div class="pj_list">
        <div class="pj_item" v-for="(item, index) in pj_list" :key="index">
          <div class="user">
            <div class="info">
              <img :src="item.avatar" class="avatar" />
              <div class="name">
                <p class="username">{{ item.username }} <img src="./img/img_icon_37.png" class="icon_vip" /></p>
                <p class="address">地址：{{ item.address }}</p>
              </div>
            </div>
            <div class="star">
              <img v-for="(item2, index2) in item.star" :key="index2" src="./img/img_icon_38.png" />
            </div>
          </div>
          <div class="pj_text">
            {{ item.text }}
          </div>
        </div>
      </div>
      <div class="vip_tips">VIP服务属虚拟商品，非故障情况，一经生效后不支持退款，请谅解。</div>
    </div>
    <div :class="['fixed_bottom', isAppleDevice ? 'iphone' : 'Noiphone']">
      <div class="bottom_left">
        <div class="left_text"><span style="font-weight: bold;">应付金额</span>：<span class="red">￥<span
              class="pay_price">{{ PayMoney_num }}</span> 元</span></div>
        <div class="left_desc" v-if="coupon_show || isWxEnv">优惠券：<span class="coupon_money">{{ coupon_money ?
          -coupon_money + ' 元' : "暂无" }}</span>
          <p>放弃,下次将原价购买</p>
        </div>
      </div>
      <button @click="payNow" class="download_btn">支付
      </button>
    </div>
    <popup ref="couponPanel" type="center" :coverClose="false">
      <div class="coupon_panel">
        <div class="panel_header">
          <div class="red_line">恭喜您，获得新人专享幸运红包
            <!-- <div class="red_bao_box" v-if="!isWxEnv"> <img class="red_img_ic"
            src="./img/alipay.png" /> 支付宝支付</div>
            <div class="red_bao_box red_bao_box_oth" v-if="isWxEnv"> <img class="red_img_ic"
              src="./img/img_icon_83.png" /> 微信支付</div> -->
          </div>
          <div class="gray_line">新用户专享首次升级会员专享</div>
        </div>
        <div class="panel_content">
          <div class="coupon_line" v-for="item in coupon_list">
            <div class="line_left"><span class="coupon_unit">￥</span>{{ item.money }}</div>
            <div class="line_right">
              <div class="right_name">{{ item.tip }}</div>
              <div class="right_desc">仅限首次会员升级使用，过期作废</div>
            </div>
          </div>
          <button class="receive_btn" @click="couponClick('use')">开心收下</button>
          <div class="light_line" @click="couponClick('skip')">我不需要优惠，原价支持</div>
        </div>
      </div>
    </popup>

    <popup ref="leavePanel" type="center" :coverClose="false">
      <div class="leave_panel">
        <img class="header_img" src="./img/img_icon_142.png" alt="">
        <div class="panel_title">亲，确定要放弃吗？</div>
        <div class="panel_subtitle">价值<span class="red_tag">200元</span>新人专属优惠券，仅限注册当日使用，过期将原价购买
        </div>
        <div class="privileges">
          <div class="priv_tips">放弃升级，您将放弃以下会员权益</div>
          <div class="priv_list">
            <div class="priv_item" v-for="priv in privileges">
              <img class="priv_icon" :src="require('./img/img_icon_' + priv.icon + '.png')" alt="">
              <div class="priv_name">{{ priv.name }}</div>
              <div class="priv_desc">{{ priv.desc }}</div>
            </div>
          </div>
        </div>
        <div class="btn_line">
          <button class="leave_btn leave" @click="skip('skip')">坚持放弃
          </button>
          <button class="leave_btn stay" @click="skip('use')">我再想想
          </button>
        </div>
        <div class="light_line">升级MJ会员，让创意照进现实</div>
      </div>
    </popup>

    <!-- 9元优惠 -->
    <div class="payClosePop" id="youyipop" v-show="fisYouh">
      <div class="payFirBox">
        <img src="./images/payImg/yhFIr.png" alt="">

        <div class="payYouDetBox">
          <div class="youTit">恭喜您</div>
          <!-- <div class="youTitip">获得新人随机1-9元专享红包</div> -->
          <div class="youTitip">获得新人随机20-50元专享红包</div>
          <div class="youTitMoBox">
            <div class="youTitRmb">¥</div>
            <div class="youTitNum">
              {{ youHuiqMoney }}
              <div class="TitNumheight" v-if="youHuiqMoney == 50">最高</div>
            </div>
            <div class="youTitRmb">元</div>
          </div>
        </div>
        <div class="getYouBtn" @click.stop="getYouhuiMon(1)">开心收下

          <div class="canrenPayBox" @click="twiceClose">
            <!-- <div class="closePayPop">X</div> -->
            甘愿落后
          </div>
        </div>
      </div>
      <div class="youhuiBg">
      </div>
    </div>
    <!-- 19元优惠 -->
    <div class="payClosePop" id="youyipop1" v-show="secYouh">
      <div class="paySecBox">
        <div class="originBaoN">
          <div class="RMBIcon">￥</div>
          50
        </div>
        <img class="secYhImg" src="./images/payImg/yhSec.png" alt="">
        <div class="payTextTip">请务必珍惜，红包被翻倍的概率仅为 <span class="readOth">0.01%</span></div>
        <div class="payYouDetBox">
          <div class="youTitMoBox">
            <div class="secYouNum">
              <div class="RMBIcon">￥</div>
              {{ youHuiqMoneySec }}
              <div class="youheight" v-show="youHuiqMoneySec == 100">最高</div>

            </div>
          </div>
        </div>
        <div class="getYouBtn" @click="getYouhuiMon(2)">点击领取</div>
        <div class="secYouhTim">
          <div class="youTimBox">
            <div class="timBItem">{{ `${Math.floor(remainingTime1 / 60).toString().padStart(2, '0')}` }}</div>
            :
            <div class="timBItem">{{ `${(remainingTime1 % 60).toString().padStart(2, '0')}` }}</div>
            :
            <div class="timBItem">{{ peakerNum3 }}</div>
            优惠失效
          </div>
        </div>
        <div class="youhuiBg2">
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import popup from "COMPONENTS/Popup.vue"
import utils from '../utils/index.js'

export default {
  components: { popup },
  data() {
    return {
      df_avatar: require("./img/unAvatar.png"),
      vipList: [
      ],
      selectedVip: {},
      coupon_money: 0,
      coupon_id: 0,
      show_money: 0,
      coupon_show: false,
      canLeave: false,
      is_donghua: false,
      uniq_key: "",
      pj_list: [{
        avatar: 'https://img2.woyaogexing.com/2024/01/17/e5b8423613757a8e3e2a03b5ab75c64a.jpg',
        username: '咖啡只能加糖',
        address: '天津',
        star: 5,
        text: '这个产品真良心，买过几家其他的，这个会员性价比最高。',
      }, {
        avatar: 'https://img2.woyaogexing.com/2024/01/17/2894e67d2a6146006211d0f2ec14ca50.jpeg',
        username: '不会游泳的娃娃鱼',
        address: '石家庄',
        star: 5,
        text: '最喜欢他家的搜索结果可以按照大图预览，真的很方便！',
      }, {
        avatar: 'https://img2.woyaogexing.com/2024/01/17/755e1712cbcc4830da6f5090ead5ccce.jpeg',
        username: 'Evening夕晴',
        address: '武汉',
        star: 5,
        text: '刚开始买了三个月，谁知道越用越顺手，直接买了终身会员。',
      }, {
        avatar: 'https://img2.woyaogexing.com/2024/01/17/f1fb0c2ac4a211f9541350a423289641.jpg',
        username: '杀死一只知更鸟',
        address: '成都',
        star: 5,
        text: '凭借其强大的图像生成能力、便捷的操作体验，为创作者们打开了一扇全新的创意之门。',
      }, {
        avatar: 'https://img2.woyaogexing.com/2024/01/16/d7d17c9514f45ca35fd7c79a274c5473.jpeg',
        username: '柠檬不萌',
        address: '广州',
        star: 5,
        text: '出图很快，是非常不错的效果图，各种风格和参数都可以用，只要描述的关键词对了就好。',
      }],
      timer0: null,
      timer1: null,
      timer2: null,
      timer3: null,
      timer4: null,
      privileges: [
        { icon: 70, name: "不限下载", desc: "图片下载 " },
        { icon: 71, name: "标签整理", desc: "MJ绘画" },
        { icon: 72, name: "智能搜索", desc: "快速生成" },
      ],
      coupon_list: [
        { money: 20, tip: '月费会员' },
        { money: 30, tip: '季度会员' },
        { money: 50, tip: '年费会员' },
        { money: 100, tip: '超级会员（终身）' },
      ],
      pay_flat: 2,
      isWxEnv: false,
      timerIds: [],
      PayMoney_num: 0,
      isAppleDevice: false,


      secYouh: false,
      youHuiqMoneySec: 0,
      youHeigShow: false,
      fisYouh: false,
      youHuiqMoney: 0,
      remainingTime1: 600,
      peakerNum3: 99,
      peakerNum2:10,
      peakerTimer2: null,
      peakerNum4: 10,
      peakerNumList: [9, 8, 7, 6, 5, 4, 3, 2, 1, 0],
      timerRemaining1: null,
      newPayData: {},
      checkTimer:null,
      hide_vip_info:[]
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    isLogin() {
      return this.$store.state.isLogin;
    }
  },
  created() {
    var ua = navigator.userAgent.toLowerCase();
    if ((ua.match(/MicroMessenger/i) == "micromessenger")) {
      this.isWxEnv = true
      this.pay_flat = 1
    } else {
      this.isWxEnv = false
      this.pay_flat = 2
    }

    this.fetchProfile()

  },
  destroyed() {
    clearInterval(this.timer);
  },
  mounted() {

    this.isAppleDevice = localStorage.getItem('isAppleDevice');

  },
  methods: {
    checkTimestamp() {
      // 是永久会员直接return
      // youhuiPopRef.value.setIsSHow(false, 0)
      this.$store.commit('setIsYouhuiPopshow', false)
      this.$store.commit('set_type', 0)
      if (this.userInfo.vip_type == 5) {
        this.$store.commit('setIsYouhuiPopshow', false)
        this.$store.commit('set_type', 0)
        return
      }

      let isTodyYouh = localStorage.getItem('isTodyYouh')
      let youhuiStatus = false
      if (isTodyYouh) {
        let start_time = isTodyYouh
        const TWELVE_HOURS = 12 * 60 * 60 * 1000; // 12小时的毫秒数

        const currentTime = Date.now();

        // 计算时间差
        const timeDiff = currentTime - parseInt(start_time, 10);
        let clientDownDate = localStorage.getItem('isTodyYouh') || 0
        // 超过12小时执行操作
        if ((timeDiff >= TWELVE_HOURS) && !clientDownDate) {
          localStorage.removeItem('isTodyYouh')
          youhuiStatus = true
        } else {
          youhuiStatus = true
        }
      } else {
        youhuiStatus = false
      }

      console.log(youhuiStatus)
      // payKeStore.checkoutKePop()
      // store.dispatch('checkIsPay',http)
    this.$http.get('/front/aimj/pay/today_order/',{params:{
      upgrade_id: `${this.userInfo.vip_type}-1`
    }}).then(res => {
        if (res.status == 200) {
          // commit('setYouhuiPayDeail', res.data);
          // commit('setNewPayPop', res.data);
          // 永久会员升级悬浮显示
          // youhuiPopRef.value.setIsSHow(true, 2)
          this.$store.commit('setIsYouhuiPopshow', true)
          this.$store.commit('set_type', 2)
        } else {
          // 永久会员优惠悬浮显示
          if (youhuiStatus) {
            console.log(1)
            // youhuiPopRef.value.setIsSHow(true, 1)
            this.$store.commit('setIsYouhuiPopshow', true)
            this.$store.commit('set_type', 1)
          }

        }
      }).catch(err => {
        if (youhuiStatus) {
          // youhuiPopRef.value.setIsSHow(true, 1)
          this.$store.commit('setIsYouhuiPopshow', true)
          this.$store.commit('set_type', 1)
          return
        }
        //悬浮消失
        // youhuiPopRef.value.setIsSHow(false, 0)
        this.$store.commit('setIsYouhuiPopshow', false)
        this.$store.commit('set_type', 0)

      })
    },
    clearTimer2() {
      if (this.timerRemaining1) {
        clearInterval(this.timerRemaining1);
        this.timerRemaining1 = null;
      }
      if (this.peakerTimer2) {
        clearInterval(this.peakerTimer2);
        this.peakerTimer2 = null;
      }
    },
    getYouhuiMon(data) {

      if (data == 1) {
        localStorage.setItem('paynum', 1)
        let today_time = new Date().getTime()
        localStorage.setItem('isTodyYouh', today_time)
        this.checkTimestamp()
        setTimeout(() => {
          this.fisYouh = false
        }, 1000);
        let youyi = document.querySelector('#youyipop')
        youyi.classList.add('payClosePopShou')
        this.vipList.forEach(item => {
          // console.log(item);

          if (item.vip_type == 5) {
            console.log('执行动画赋值');

            item.privilege = this.hide_vip_info[0].privilege
            item.vip_id = 'level_5'
            utils.animateNumber(parseInt(item.raw_money), parseInt(item.raw_money) - 50, (newValue) => {
              item.raw_money = newValue
            }, 50)
            if (this.selectedVip.vip_type == 5) {
              this.newPayData = 'level_5'
            }
          }
        })
        this.animateNumberNew(parseInt(this.PayMoney_num), parseInt(this.PayMoney_num) - 50, (newValue) => {
          if (this.selectedVip.vip_type == 5) {
            this.PayMoney_num = newValue
          }
        }, 50)
        // utils.animateNumber(parseInt(PayMoney_num.value), parseInt(PayMoney_num.value) - 50, (newValue) => {
        //   console.log(newValue)
        //   PayMoney_num.value = newValue
        // }, 50)
        // setTimeout(() => {
        //   isYouhuiShow.value = true
        // }, 1000);
        // youhuiMoney.value = 9
        // getYouHuiMoney()
        // clearTimer();
        if (this.selectedVip.vip_type == 5) {
          this.coupon_money = 150
        }
      } else {
        clearInterval(this.timer1)
        let today_time = new Date().getTime()
        localStorage.setItem('isTodyYouh', today_time)
        this.checkTimestamp()
        setTimeout(() => {
          this.secYouh = false
        }, 1000);
        localStorage.setItem('paynum', 2)
        // youhuiMoney.value = 19
        let youyi = document.querySelector('#youyipop1')
        youyi.classList.add('payClosePopShou1')

        // getYouHuiMoney()
        // clearTimer2()
        // setTimeout(() => {
        //   isYouhuiShow2.value = true
        // }, 1000);
        this.clearTimer2()
        this.vipList.forEach(item => {
          if (item.vip_type == 5) {
            // 终身会员
            item.raw_money = 149
            item.privilege = this.hide_vip_info[1].privilege
            item.vip_id = 'level_6'
            if (this.selectedVip.vip_type == 5) {
              this.PayMoney_num = 149
              this.newPayData = 'level_6'
            }
            utils.animateNumber(item.raw_money, item.raw_money - 50, (newValue) => {
              item.raw_money = newValue
            }, 50)
          }
        })
        this.animateNumberNew(parseInt(this.PayMoney_num), parseInt(this.PayMoney_num) - 50, (newValue) => {
          if (this.selectedVip.vip_type == 5) {
            this.PayMoney_num = newValue
          }
        }, 50)
        if (this.selectedVip.vip_type == 5) {
          this.coupon_money = 200
        }
      }
    },
    twiceClose() {
      setTimeout(() => {
        this.secYouh = true
        // animateValue(90,100,4000)

        utils.animateNumber(50, 100, (newValue) => {
          console.log(newValue)
          this.youHuiqMoneySec = newValue
          if (youHuiqMoneySec == 100) {
            this.youHeigShow = true
          }
        }, 20)

        this.startTimer2()
      }, 1000);
    },


    stopSetTime() {
      this.timerIds.forEach(timerId => {
        clearInterval(timerId)
      })
      this.vipList.forEach(item => {
        //if(this.pay_flat==1){//微信
        item.raw_money = Number(item.pay_money)
        //}else{//支付宝
        //item.raw_money = item.pay_money
        //}
      })
      //this.$forceUpdate()
      this.timerIds = []
    },
    stopSetTime2() {
      this.timerIds.forEach(timerId => {
        clearInterval(timerId)
      })
      this.vipList.forEach(item => {
        if (item.vip_type == 5) {
          item.privilege = this.hide_vip_info[0].privilege
          if (!this.userInfo.vip_type) {
            if (localStorage.getItem('getY')) {
              item.raw_money = parseInt(item.pay_money) - item.coupon_money - 50
            } else {
              item.raw_money = parseInt(item.pay_money) - 50
            }
          } else {
            item.raw_money = parseInt(item.pay_money) - item.coupon_money - 50
          }
        } else {
          if (!this.userInfo.vip_type) {
            if (localStorage.getItem('getY')) {
              item.raw_money = parseInt(item.pay_money) - item.coupon_money
            } else {
              item.raw_money = parseInt(item.pay_money)
            }
          } else {
            item.raw_money = parseInt(item.pay_money) - item.coupon_money

          }
        }
      })
      //this.$forceUpdate()
      this.timerIds = []
    },
    stopSetTime3() {
      this.timerIds.forEach(timerId => {
        clearInterval(timerId)
      })
      this.vipList.forEach(item => {
        if (this.pay_flat == 1) {//微信
          item.raw_money = Number(item.pay_money)
        } else {//支付宝
          item.raw_money = Number(item.pay_money)
        }
      })
      //this.$forceUpdate()
      this.timerIds = []
    },
    getBottYouhui(){
      if (localStorage.getItem('paynum')) {
        if (this.selectedVip.vip_type == 5) {
          if (localStorage.getItem('paynum') == 1) {
            this.coupon_money = 150
          } else {
            this.coupon_money = 200
          }
        }
      }
    },
    changePayType(data) {
      let cuPay = this.pay_flat
      if (cuPay == data) {
        return
      }
      this.pay_flat = data
      this.getBottYouhui()
      // this.stopSetTime()
      // if (data == 2) {//支付宝减去10
      //     this.vipList.forEach(item => {
      //         item.raw_money = Number(item.raw_money)
      //         item.raw_money -= Number(item.coupon_money)
      //     })
      //     this.$forceUpdate()
      // } else {//微信+10
      //     this.vipList.forEach(item => {
      //         item.raw_money = Number(item.raw_money)
      //         //item.raw_money +=Number(item.coupon_money)
      //     })
      // }
      // this.$forceUpdate()
      // setTimeout(() => {


      //     this.animateNumberNew(Number(this.selectedVip.raw_money) + 10, this.selectedVip.raw_money, (newValue) => {
      //         console.log(newValue);
      //         //currentNumber = newValue;
      //         this.PayMoney_num = newValue
      //     })
      // })
    },
    animateNumberNew(current, target, callback, time = 10) {
      let isIncreasing = current < target
      this.timer12 = setInterval(() => {
        if ((isIncreasing && current >= target) || (!isIncreasing && current <= target)) {
          clearInterval(this.timer12)
          return
        }

        current += isIncreasing ? 1 : -1
        callback(current)
      }, time)
    },
    animateNumber(current, target, callback) {
      let isIncreasing = current < target;
      let intervalId = setInterval(() => {
        if ((isIncreasing && current >= target) || (!isIncreasing && current <= target)) {
          clearInterval(intervalId);
          return;
        }

        current += isIncreasing ? 1 : -1;
        callback(current);
      }, 30);

      // 返回一个可以手动停止的方法
      return {
        stop: () => {
          clearInterval(intervalId);
        }
      };
    },
    fetchProfile(callback) {
      let invite_code = localStorage.getItem("invite_code") || "";

      this.$http.get(`/front/user/profile/`, { params: { invite_code: invite_code, app_id: APP_ID } }).then(res => {
        if (res.status == '200') {
          this.$store.commit('setUserInfo', res.data)
          localStorage.setItem("userinfo", JSON.stringify(res.data));
          if (callback) callback(res.data);
          this.fetchGoodsList();
        }
      }).finally(() => {

      })
    },
    fetchGoodsList() {
      this.$http.get('/front/aimj/pay/membership/',{
        params: {
          is_score: 0
        }
      }).then((res) => {
        if (res.status == 200) {
          // this.coupon_list = res.data.coupon_list
          this.pay_flat == 1
          this.hide_vip_info = res.data.hide_vip_info

          this.selectedVip = res.data.vip_info[res.data.vip_info.length - 1]
          if (localStorage.getItem('paynum')) {
            // 个人会员 且领取过 优惠券

            if (localStorage.getItem('paynum') == 1) {
              // res.data.vip_info.forEach(item => {
              console.log(this.vipList);
              this.newPayData = 'level_5'
              res.data.vip_info.forEach(item => {
                if (item.vip_type == 5) {
                  item.vip_id = 'level_5'
                  item.privilege = this.hide_vip_info[0].privilege
                  if (!this.userInfo.vip_type) {
                    if (localStorage.getItem('getY')) {
                      item.raw_money = parseInt(item.pay_money) - item.coupon_money - 50
                    } else {
                      item.raw_money = parseInt(item.pay_money) - 50
                    }
                  } else {
                    item.raw_money = parseInt(item.pay_money) - item.coupon_money - 50
                  }
                } else {
                  if (!this.userInfo.vip_type) {
                    if (localStorage.getItem('getY')) {
                      item.raw_money = parseInt(item.pay_money) - item.coupon_money
                    } else {
                      item.raw_money = parseInt(item.pay_money)
                    }
                  } else {
                    item.raw_money = parseInt(item.pay_money) - item.coupon_money

                  }
                }
              })
              this.coupon_show = true
              this.coupon_money = 150
            } else if (localStorage.getItem('paynum') == 2) {
              this.newPayData = 'level_6'
              res.data.vip_info.forEach(item => {
                if (item.vip_type == 5) {
                  item.privilege = this.hide_vip_info[1].privilege
                  item.vip_id = 'level_6'
                  if (!this.userInfo.vip_type) {
                    if (localStorage.getItem('getY')) {
                      item.raw_money = parseInt(item.pay_money) - item.coupon_money - 100
                    } else {
                      item.raw_money = parseInt(item.pay_money) - 100
                    }
                  } else {
                    item.raw_money = parseInt(item.pay_money) - item.coupon_money - 100
                  }
                } else {
                  if (!this.userInfo.vip_type) {
                    if (localStorage.getItem('getY')) {
                      item.raw_money = parseInt(item.pay_money) - item.coupon_money
                    } else {
                      item.raw_money = parseInt(item.pay_money)
                    }
                  } else {
                    item.raw_money = parseInt(item.pay_money) - item.coupon_money
                  }
                }
              })
              // res.data.vip_info[res.data.vip_info.length - 1].pay_money = parseInt(res.data.vip_info[res.data.vip_info.length - 1].pay_money) - 10
              this.coupon_show = true
              this.isYouhuiShow2 = true
              this.coupon_money = 200
            }
          } else if (localStorage.getItem('getY') || this.userInfo.vip_type) {
            // 个人会员领取过 通用 优惠券
            res.data.vip_info.forEach(item => {
              item.raw_money = parseInt(item.pay_money) - item.coupon_money
            })
            this.newPayData = 'level_4'
            this.coupon_money = 100
          }

          // this.stopSetTime3()
          this.vipList = res.data.vip_info;
          this.PayMoney_num = this.vipList[this.vipList.length - 1].raw_money
          if (!this.userInfo.vip_type&&!localStorage.getItem('getY')) {
            this.$refs.couponPanel.show();
          } else {
            this.coupon_show = true;
          }
        }
      })
    },
    chooseSetMeal(vip) {
      console.log('选择的');
      console.log(vip);
      
      clearInterval(this.checkTimer)
      this.coupon_id = vip.coupon_id;
      this.selectedVip = vip
      this.newPayData = vip.vip_id
      if(vip.vip_type!=5){
        this.coupon_money = vip.coupon_money;
      }else{
        this.getBottYouhui()
      }
      
      // if (this.pay_flat == 2) {
      if(this.timerIds.length){
        this.stopSetTime2()
      }
      // } else {
      //   if(this.isWxEnv){
      //     this.stopSetTime2()
      //   }else{
      //     this.stopSetTime()
      //   }

      // }
      setTimeout(() => {
        this.PayMoney_num = vip.raw_money
      })

    },
    payNow() {
      if (!this.isLogin) {
        this.$store.commit('setShowLogin', true)
        return
      }
      // 立即支付
      // 如果支付二维码可以放在 pay_flats 列表中，就不需要请求接口了 isWxEnv
      let pay_from = "h5pay"
      let pay_source = "wap"
      if (this.isWxEnv) {
        pay_source = "wapwx"
      }
      if (!this.isWxEnv && this.pay_flat == 1) {
        pay_from = "h5wxpay"
      }
      let data = {
        "appid": APP_ID,
        "pay_source": this.isWxEnv ? pay_source : "wap",
        "pro_id": 0,
        "pay_type": this.selectTab,
        "vip_type": this.selectedVip.vip_type,
        "pay_from": this.isWxEnv ? pay_from : "h5pay",
        "pay_flat": this.pay_flat,
        // "coupon_id": this.coupon_id,
        "vip_id":this.newPayData,
        "is_upgrade":0

      }
      console.log(data)
      console.log(this.selectedVip)

      // data.APP_ID = APP_ID

      this.$http.post('/front/aimj/pay/chongzhi/', data).then((res) => {
        if (res.status == 200) {
          // return
          if (![4, 5].includes(data.vip_type)) {
            // this.checkoutKePop()
            localStorage.setItem('isTopay', true)
          }
          this.code_url = res.data.pay_url;
          this.uniq_key = res.data.uniq_key;
          this.checkTimer = setInterval(()=>{
            this.chongzhiSta(res.data.uniq_key)
          },3000)

          let code_url = res.data.pay_url;
          let userAgent = navigator.userAgent;
          let isAndroid = userAgent.indexOf('Android') > -1 || userAgent.indexOf('Linux') > -1;
          let isIOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

          if (isAndroid) {
            // 执行Android相关的代码
            window.open(code_url);
          }

          if (isIOS) {
            // 执行iOS相关的代码
            // alert('ios')
            var winRef = window.open(" ","_self")
            winRef.location = code_url
            localStorage.setItem('_goPay',true)
          }

        }
      })
    },
    paySuccess(){
      // this.$store.commit('setNewPayPop',true)
      this.$store.commit('setVipCongratulationsShow',true)
      // this.$store.commit('set_type',2)

    },
    chongzhiSta(data){
        this.$http.get('/pay/order/status/',{
                        params:{
                    uniq_key:data
                }
              }).then(res=>{
                if(res.data.code){
                  clearInterval(this.checkTimer)
                  this.$http.get(`/front/user/profile/`).then(user => {
                    if (user.status == 200) {
                      this.$store.commit('setUserInfo',user.data)
                      //支付成功弹出恭喜您称为xxx会员弹窗
                      this.$store.commit('setVipCongratulationsShow', true) 
                      if(user.data.vip_type==5){
                        this.$store.commit('setIsYouhuiPopshow', false)
                      }
                      // if(user.data.vip_type==5){
                      //   //更改
                      //   // this.$store.commit('setcomVipShow',true)
                      // }else{
                      //   // this.$store.commit('setNewPayPop',true)
                      //   // this.getTodyOrder()
                      // }
                    }
                  })
                }
              })
},
getTodyOrder(){
    this.$http.get('/front/aimj/pay/today_order/').then(res => {
      if(res.status==200){
          clearInterval(this.checkTimer)
          this.$store.commit('setYouhuiPayDeail',res.data)
          this.$store.commit('setIsYouhuiPopshow',true)
          this.$store.commit('set_type',2)
      }
      if(res.status==-1){
          clearInterval(this.checkTimer)
          this.$store.commit('setIsYouhuiPopshow',false)

      }
  }).catch(err=>{
    console.log('错误');
    console.log(err);
    // if(err.status==500){
      clearInterval(this.checkTimer)
      if(localStorage.getItem('isTodyYouh')){
        this.$store.commit('setIsYouhuiPopshow',true)
        this.$store.commit('set_type',1)
      }else{
        this.$store.commit('setIsYouhuiPopshow',false)
      }
    // }         

  })
},
    couponClick(action) {
      // if(action=="use"||action=="skip"){
      //if (action == "use") {
      //this.chooseSetMeal(this.vipList[this.vipList.length - 1], 0, 0);
      localStorage.setItem('getY', true)
      this.vipList.forEach((vip, index) => {
        if (vip.raw_money == '299') {
          let coupon_m = this.coupon_list[index] ? this.coupon_list[index].money : 100;
          let finallyPrice = 0
          if (this.pay_flat == 1) {
            if (this.isWxEnv) {
              finallyPrice = vip.raw_money - vip.coupon_money
            } else {
              finallyPrice = vip.raw_money
            }
          } else {
            finallyPrice = vip.raw_money - vip.coupon_money
          }
          let timer = setInterval(() => {
            //vip.raw_money = vip.raw_money - Math.floor(coupon_m / 20);
            vip.raw_money = vip.raw_money - 2
            this.PayMoney_num = vip.raw_money - 2
            //if(vip.raw_money==59){
            // vip.raw_money = 49
            //}
            if (vip.raw_money <= finallyPrice) {
              this.PayMoney_num = finallyPrice
              vip.raw_money = finallyPrice;
              clearInterval(timer);
            }
          }, 30)
          this.timerIds.push(timer)
        } else {
          let coupon_m = this.coupon_list[index] ? this.coupon_list[index].money : 100;
          let finallyPrice = 0
          if (this.pay_flat == 1) {
            if (this.isWxEnv) {
              finallyPrice = vip.raw_money - vip.coupon_money
            } else {
              finallyPrice = vip.raw_money
            }
          } else {
            finallyPrice = vip.raw_money - vip.coupon_money
          }
          let timer = setInterval(() => {
            //vip.raw_money = vip.raw_money - Math.floor(coupon_m / 20);
            vip.raw_money = vip.raw_money - 2
            //if(vip.raw_money==59){
            // vip.raw_money = 49
            //}
            if (vip.raw_money <= finallyPrice) {
              console.log('zhixing', index)
              vip.raw_money = finallyPrice;
              clearInterval(timer);
            }
          }, 30)
          this.timerIds.push(timer)
        }
      })
      //if (this.coupon_show && this.is_donghua == false) {
      //  this.vipList.forEach(item => {
      //    this.donghua(item)
      //  });
      //}
      this.coupon_show = true;
      this.coupon_money = 100
      //}
      this.$refs.couponPanel.close();


    },
    skip(action) {
      if (action == "use") {
        this.canLeave = true;
        this.$refs.leavePanel.close();
      } else {
        this.canLeave = true;
        this.$router.push(this.toUrl);
      }
    },
    donghua(vipItem) {
      vipItem.raw_money = Number(vipItem.pay_money) + vipItem.coupon_money
      let finallyPrice = vipItem.raw_money - vipItem.coupon_money
      console.log(finallyPrice)
      let timer = setInterval(() => {
        this.is_donghua = true
        vipItem.raw_money = vipItem.raw_money - 2;
        if (vipItem.raw_money <= finallyPrice) {
          vipItem.raw_money = finallyPrice;
          clearInterval(timer);
          this.$forceUpdate()
        }
      }, 50)
    },
    donghua0(vip) {
      let show_money = Number(vip.show_money);
      let step = 2;
      let showMoeny = show_money
      this.is_donghua = true
      showMoeny = show_money - vip.coupon_money;
      if (this.timer0)
        clearInterval(this.timer0);
      this.timer0 = setInterval(() => {
        show_money -= step;
        vip.show_money -= step
        if (show_money <= showMoeny) {
          show_money = showMoeny;
          clearInterval(this.timer0);
        }
      }, 50)
    },
    donghua1(vip) {
      let show_money = Number(vip.show_money);
      let step = 2;
      let showMoeny = show_money
      this.is_donghua = true
      showMoeny = show_money - vip.coupon_money;
      if (this.timer1)
        clearInterval(this.timer1);
      this.timer1 = setInterval(() => {
        show_money -= step;
        vip.show_money -= step
        if (show_money <= showMoeny) {
          show_money = showMoeny;
          clearInterval(this.timer1);
        }
      }, 50)
    },
    donghua2(vip) {
      let show_money = Number(vip.show_money);
      let step = 2;
      let showMoeny = show_money
      this.is_donghua = true
      showMoeny = show_money - vip.coupon_money;
      if (this.timer2)
        clearInterval(this.timer2);
      this.timer2 = setInterval(() => {
        show_money -= step;
        vip.show_money -= step
        if (show_money <= showMoeny) {
          show_money = showMoeny;
          clearInterval(this.timer2);
        }
      }, 50)
    },
    donghua3(vip) {
      let show_money = Number(vip.show_money);
      let step = 2;
      let showMoeny = show_money
      this.is_donghua = true
      showMoeny = show_money - vip.coupon_money;
      if (this.timer3)
        clearInterval(this.timer3);
      this.timer3 = setInterval(() => {
        show_money -= step;
        vip.show_money -= step
        if (show_money <= showMoeny) {
          show_money = showMoeny;
          clearInterval(this.timer3);
        }
      }, 50)
    },
    donghua4(vip) {
      let show_money = Number(vip.show_money);
      let step = 2;
      let showMoeny = show_money
      this.is_donghua = true
      showMoeny = show_money - vip.coupon_money;
      if (this.timer4)
        clearInterval(this.timer4);
      this.timer4 = setInterval(() => {
        show_money -= step;
        vip.show_money -= step
        if (show_money <= showMoeny) {
          show_money = showMoeny;
          clearInterval(this.timer4);
        }
      }, 50)
    },
    startTimer2() {
      this.timerRemaining1 = setInterval(() => {
        if (this.remainingTime1 > 0) {
          // console.log(new Date().getSeconds())
          this.remainingTime1 -= 1;
        } else {
          this.clearTimer2();
        }
      }, 1000);
      this.peakerTimer2 = setInterval(() => {
        this.peakerNum3 -= 1
        this.peakerNumList.forEach((item, index) => {
          if (this.peakerNum3 == item) {
            this.peakerNum3 = Math.floor(Math.random() * (((item * 10) + 10) - (item * 10) + 1)) + (item * 10)
            this.peakerNum3 === 100 ? this.peakerNum3 - 1 : this.peakerNum3 <= 0 ? this.peakerNum3 + 1 : this.peakerNum3
            // peakerNum3.value = Math.floor((Math.random() * (item*10)))
            this.peakerNum3 < 10 ? this.peakerNum3 = '0' + this.peakerNum3 : this.peakerNum3
            // console.log('peakerNum1>>'+  peakerNum1.value)
            this.peakerNum4 === 0 ? this.peakerNum4 = 10 : this.peakerNum4
          }
        })
      }, 100)
    },
  },
  beforeRouteLeave(to, form, next) {
    if (this.canLeave) {
      next();
    } else {
      this.fetchProfile((data) => {
        console.log(data);
        if (data.vip_type != 5) {
          if (localStorage.getItem('paynum')) {
            //根据
            if (localStorage.getItem('paynum') == 1) {
              // fisYouh.value = true
              this.secYouh = true
              // animateValue(90,100,4000)

              utils.animateNumber(50, 100, (newValue) => {
                console.log(newValue)
                this.youHuiqMoneySec = newValue
                if (this.youHuiqMoneySec == 100) {
                  this.youHeigShow = true
                }
              }, 20)

              this.startTimer2()
              next(false);
            } else if (localStorage.getItem('paynum') == 2) {
              next()
            }

          } else {
            this.fisYouh = true
            let timer = null
            timer = setInterval(() => {
              this.youHuiqMoney = utils.getRandomInt(20, 49)
            }, 200);
            setTimeout(() => {
              clearInterval(timer)
              this.youHuiqMoney = 50
            }, 3000);
            next(false);
          }
        } else {
          next()
        }

      })
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.exchange_wrap {
  //font-size: 12px;
  font-size: 0.75rem;
  line-height: 1.5;
  height: 100%;
  overflow-y: auto;
  background-color: #f5f5f5;

  .page_top {
    //height: 60px;
    padding: 10px 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 3px 3px 6px -2px #dfdfdf;

    .top_left {
      display: flex;
      align-items: center;

      .user_head {
        width: 31px;
        height: 31px;
        border-radius: 50%;
        margin-right: 6px;
        border-radius: 50%;
        border: 2px solid #fff;
      }

      .user_info {
        .user_name {
          color: black;
          font-weight: bold;
          //line-height: 17px;
          font-size: 0.625rem;
        }

        .user_id {
          font-size: 0.625rem;
          //line-height: 17px;
          color: #ccc;
        }
      }
    }

    .top_right {
      text-align: right;
      color: #ccc;
      font-size: 0.625rem;

      .identify {
        color: black;
      }
    }
  }

  .tab_line {
    margin-top: 10px;
    color: #fff;
    //font-size: 16px;
    font-size: 1rem;

    .charge_tab {
      display: flex;
      gap: 10px;
      padding: 4px;
      background-color: rgb(29, 30, 35);
      border-radius: 9999px;

      .tab_item {
        width: 150px;
        height: 45px;
        border-radius: 1000px;
        cursor: pointer;
        font-weight: 700;

        &.selected {
          font-weight: normal;
          background: linear-gradient(90deg, #6506dd 0%, #e32b97 100%);
        }

        .pay_tag {
          font-weight: 400;
          padding: 2px 8px;
          margin-left: 5px;
          //font-size: 12px;
          font-size: 0.75rem;
          background-color: rgba(255, 255, 255, 0.19);
          border-radius: 999px;

          .tag_img {
            width: 14px;
            height: 14px;
            margin-left: 5px;
            border: none;
          }
        }
      }

    }
  }

  .page_content {
    padding: 15px 15px 115px;

    .vip_list {
      display: flex;
      justify-content: space-between;
      margin-bottom: 5px;
      gap: 6px;

      .vip_item {
        width: 103px;
        height: 161px;
        background-color: #fff;
        border-radius: 2.5px;
        border: 1px solid #e9e9e9;
        padding-top: 12px;
        background-image: url("./img/img_icon_28.png");
        background-size: 100% auto;
        background-repeat: no-repeat;
        background-position: top center;
        box-shadow: 0 -2px 8px 1px #aaa;
        ;
        text-align: center;
        cursor: pointer;
        overflow: hidden;

        &.active {
          background-image: url("./img/img_icon_29.png");
          border-color: #fadaba;
          position: relative;

          &::after {
            content: "";
            display: block;
            width: 30px;
            height: 30px;
            position: absolute;
            bottom: 0;
            right: 0;
            background-image: url("./img/img_icon_30.png");
            background-size: 100% 100%;
          }
        }

        .vip_icon {
          width: 38px;
          height: 38px;
          border-radius: 50%;
          border: 1px solid #eee;
          padding-top: 6px;
          margin: 0 auto 2.5px;

          .icon_img {
            display: block;
            margin: 0 auto;
            width: 21px;
          }
        }

        .vip_name {
          font-weight: bold;
          //line-height: 20px;
          color: #333;
        }

        .vip_price {
          //font-size: 11px;
          font-size: 0.625rem;
          //line-height: 17px;
          color: #e22222;
        }

        .vip_desc {
          color: #ccc;
          //line-height: 16px;
          font-size: 0.625rem;
          white-space: nowrap;

          .origin_price {
            text-decoration: line-through;
            text-decoration-color: #e22222;
          }
        }
      }
    }

    .vip_tips {
      margin-top: 10px;
      color: #c9c9c9;
      //line-height: 19px;
      text-align: center;
      //font-size: 11px;
      font-size: 0.625rem;
    }
  }

  .fixed_bottom {
    position: fixed;
    width: 100%;
    //height: 60px;
    left: 0;
    bottom: 55px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0 -2px 10px 0 rgba(75, 91, 138, .1);

    &.iphone {
      //height: 66px;
      padding: 0 13px 6px 16px;

    }

    &.Noiphone {
      //height: 60px;
      padding: 0 13px 0px 16px;

    }

    .bottom_left {
      .left_text {
        color: black;

        .red {
          color: #ec3b3b;

          .pay_price {
            //font-size: 18px;
            font-size: 1.125rem;
          }
        }
      }

      .left_desc {
        color: #c9c9c9;

        .coupon_money {
          color: #e22222;
        }

        p {
          display: inline-block;
          background-color: #f3c3c3;
          color: #e22222;
          padding: 1.5px 2.5px 0;
          border-radius: 1.5px;
          //font-size: 10px;
          font-size: 0.625rem;
          margin-left: 5px;
        }
      }
    }

    .download_btn {
      border-radius: 2.5px;
      height: 32px;
      border: none;
      //width: 65px;
      padding: 0 20px;
      ;
      background-color: #ec3b3b;
      color: #fff;
      box-shadow: 0 0 5px #ec3b3b;
      //font-size:14px;
      font-size: 0.75rem;
    }
  }
}

.coupon_panel {
  color: #333;
  width: 310px;
  //background-image: url("./img/img_icon_111.gif");
  background-image: url("./img/img_icon_40_1.png");
  //background-size: 100% 60%;
  background-size: contain;
  background-repeat: no-repeat;
  position: relative;
  padding-top: 26px;
  text-align: center;
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 25px;


  .panel_content {
    background-color: #fff;
    border-bottom-left-radius: 25px;
    border-bottom-right-radius: 25px;
    padding: 0px 24px;
    padding-top: 15px;

  }

  .red_line {
    font-size: 14px;
    font-size: 0.75rem;
    color: #ec3b3b;
    font-weight: bold;
    line-height: 28px;
    margin-top: 50px;
    display: flex;
    align-items: center;
    justify-content: center;

    .red_bao_box {
      .red_img_ic {
        width: 14px;
        height: 14px;
        margin-right: 5px;
        font-size: 0;
      }

      display: flex;
      align-items: center;
      color: #019fe8;
      margin: 0 5px;
      vertical-align: middle;
    }

    .red_bao_box_oth {
      color: #139c00;
    }
  }

  .gray_line {
    color: #999;
    //font-size: 12px;
    font-size: 12px;
    //line-height: 28px;
    //margin-bottom: 10px;
  }

  .coupon_line {
    display: flex;
    align-items: center;
    //height: 55px;
    margin-bottom: 10px;
    background-image: url("./img/img_icon_81.png");
    background-size: 100% 100%;

    .line_left {
      width: 72px;
      flex-shrink: 0;
      //font-size: 26px;
      font-size: 1.5rem;
      margin-top: 5px;
      color: #ec3b3b;
      font-weight: bold;

      .coupon_unit {
        //font-size: 14px;
        font-size: 0.875rem;
      }
    }

    .line_right {
      flex-grow: 1;
      padding-left: 12px;
      text-align: left;

      .right_name {
        font-weight: bold;
        //font-size: 12px;
        font-size: 0.625rem;
        line-height: 18px;
      }

      .right_desc {
        //font-size: 11px;
        font-size: 0.5rem;
        line-height: 18px;
        color: #999;
      }
    }
  }

  .receive_btn {
    display: block;
    width: 253px;
    height: 41px;
    margin: 0 auto;
    color: #fff;
    background-color: #ec3b3b;
    border: none;
    border-radius: 21px;
    //font-size: 12px;
    font-size: 0.625rem;
  }

  .light_line {
    //line-height: 53px;
    color: #ccc;
    //font-size: 12px;
    font-size: 0.625rem;
    padding: 15px 0;
  }

  .close_btn {
    position: absolute;
    bottom: 0;
    left: 50%;
    margin-left: -18px;
    width: 36px;
    height: 36px;
    background-image: url("./img/img_icon_12.png");
    background-size: 100% 100%;
    cursor: pointer;
    border-radius: 50%;
  }
}

.leave_panel {
  width: 300px;
  background-color: #fff;
  border-radius: 12px;
  padding: 34px 15px 16px;
  text-align: center;

  .header_img {
    position: absolute;
    width: 82px;
    display: block;
    top: -21.5px;
    left: 102px;
  }

  .panel_title {
    //font-size: 12px;
    font-size: 0.75rem;
    //line-height: 20px;
    color: #e22222;
    margin-bottom: 10px;
  }

  .panel_subtitle {
    //font-size: 12px;
    font-size: 0.75rem;
    //line-height: 20px;
    margin-bottom: 10px;
    color: #000;

    .red_tag {
      display: inline-block;
      padding: 0 6px;
      border-radius: 2px;
      background-color: #e22222;
      color: #fff;
      //line-height: 16px;
      margin: 0 6px;
    }
  }

  .privileges {
    border-top: 1px dashed #ccc;
    padding: 9px 8px 21px;

    .priv_tips {
      //font-size: 12px;
      font-size: 0.75rem;
      //line-height: 36px;
      color: #999;
      margin-bottom: 18px;
    }

    .priv_list {
      display: flex;
      justify-content: space-between;

      .priv_item {
        .priv_icon {
          width: 28px;
          display: block;
          margin: 0 auto 8px;
        }

        .priv_name {
          //font-size: 12px;
          font-size: 0.75rem;
          //line-height: 22px;
        }

        .priv_desc {
          //font-size: 12px;
          font-size: 0.75rem;
          //line-height: 26px;
          color: #999;
        }
      }
    }
  }

  .btn_line {
    display: flex;
    justify-content: space-between;

    .leave_btn {
      display: block;
      width: 120px;
      height: 30px;
      border-radius: 5px;
      border: none;
      //font-size: 12px;
      font-size: 0.75rem;
      margin-bottom: 15px;

      &.leave {
        background-color: #dddddd;
        color: #999;
      }

      &.stay {
        background-color: #e22222;
        color: #fff;
      }
    }
  }

  .light_line {
    //font-size: 11px;
    font-size: 0.625rem;
    //line-height: 16px;
    color: #ccc;
  }
}

.vip_list2 {
  padding-bottom: 10px;

  .list_type1 {
    display: flex;
    justify-content: space-between;
    //align-items: center;
    background: #fff;
    border: 1px solid #fff;
    position: relative;

    .icon {
      padding: 18px;
      background-image: url("./img/img_icon_28.png");
      background-size: 100% auto;
      background-repeat: no-repeat;
      background-position: top center;

      .vip_icon {
        width: 38px;
        height: 38px;
        border-radius: 50%;
        border: 1px solid #eee;
        padding-top: 6px;
        margin: 0 auto 2.5px;

        .icon_img {
          display: block;
          margin: 0 auto;
          width: 21px;
        }
      }

      .vip_name {
        font-weight: bold;
        //font-size: 14px;
        font-size: 0.75rem;
        color: #333;
      }
    }

    .price_area {
      flex: 1;
      text-align: center;
      padding: 5px 10px 0;

      .price {
        //font-size: 12px;
        font-size: 0.625rem;
        color: #666;
        border-bottom: 1px dotted #999;

        .strong {
          //font-size: 26px;
          font-size: 1.25rem;
          font-weight: bold;
          color: #000;
          margin: 0 6px;
        }

        .throo {
          text-decoration: line-through;
          text-decoration-color: red;
        }
      }

      .desc {
        //font-size: 12px;
        font-size: 0.625rem;
        color: #999;
        padding-top: 10px;
      }
    }

    .hot {
      // display: none;
      //width: 89px;
      //height: 26px;
      position: absolute;
      top: -10px;
      right: -6px;
      background-image: url("./img/img_icon_35.png");
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      //line-height: 23px;
      color: #fff;
      text-align: center;
      vertical-align: top;
      display: inline-block;
      padding: 0px 3px 4px;

      span {
        display: block;

        font-size: 0.625rem;
        //padding: 0 0 5px 5px;
      }
    }

    &.active {
      border-color: #fadaba;

      .hot {
        display: block;
      }

      .icon {
        background-image: url("./img/img_icon_29.png");
        background-size: 100% auto;
      }

      &::after {
        content: "";
        display: block;
        width: 30px;
        height: 30px;
        position: absolute;
        bottom: 0;
        right: 0;
        background-image: url("./img/img_icon_30.png");
        background-size: 100% 100%;
      }
    }
  }
}

.vip_list3 {
  display: flex;
  justify-content: space-between;
  margin-bottom: 7.5px;
  gap: 5px;

  .vip_item {
    //width: 115px;
    padding: 5px;
    background-color: #fff;
    border-radius: 8px;
    border: 1px solid #e9e9e9;
    padding-top: 15px;
    background-image: url("./img/img_icon_28.png");
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-position: top center;
    text-align: center;
    cursor: pointer;
    overflow: hidden;
    flex: 1;

    &.active {
      background-image: url("./img/img_icon_29.png");
      border-color: #fadaba;
      position: relative;

      &::after {
        content: "";
        display: block;
        width: 30px;
        height: 30px;
        position: absolute;
        bottom: 0;
        right: 0;
        background-image: url("./img/img_icon_30.png");
        background-size: 100% 100%;
      }
    }

    .vip_icon {
      width: 38px;
      height: 38px;
      border-radius: 50%;
      border: 1px solid #eee;
      padding-top: 6px;
      margin: 0 auto 2.5px;

      .icon_img {
        display: block;
        margin: 0 auto;
        width: 21px;
      }
    }

    .vip_name {
      font-size: 0.625rem;
      font-weight: bold;
      //line-height: 20px;
      color: #333;
    }

    .vip_price {
      //font-size: 24px;
      font-size: 0.875rem;
      color: #333;

      .small {
        //font-size: 11px;
        font-size: 0.625rem;
      }
    }

    .vip_desc {
      color: #666;
      //line-height: 16px;
      //font-size: 9px;
      font-size: 0.5rem;
      white-space: nowrap;
      margin: 5px 15px 0;
      padding: 5px 0;
      border-top: 1px dashed #d7d7d7;

      .origin_price {
        text-decoration: line-through;
        text-decoration-color: #e22222;
      }
    }
  }
}

.pay_type {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;

  .pay_item {
    //width: 158px;
    width: 45%;
    height: 50px;
    display: flex;
    align-items: center;
    padding: 0 11px;
    font-size: 16px;
    border-radius: 2px;
    position: relative;
    margin-top: 10px;

    .pay_sel_top {
      position: absolute;
      top: -13px;
      left: -8px;
      width: 80px;
      height: 25px;
      width: 95px;

      .pay_sel_top_img {
        font-size: 0;
        width: 100%;
        height: 100%;
      }

      .pay_sel_top_text {
        position: absolute;
        left: 8px;
        top: 50%;
        transform: translateY(-55%);
        font-size: 12px;
        color: #fff;
      }
    }

    &.ali_pay {
      border: 1px solid #c7eeff;
      background-color: #f4fcff;
      color: #0092e5;

      &.selected {
        border-color: #0092e5;
      }
    }

    &.wx_pay {
      border: 1px solid #d2f4cc;
      background-color: #e3f8e0;
      color: #139c00;
      //margin-left: 20px;

      &.selected {
        border-color: #139c00;
      }
    }

    &.selected {
      .select_icon {
        display: block;
      }
    }

    .pay_type_icon {
      width: 18px;
      vertical-align: middle;
      margin: 0px 8px 0 0;
    }

    .select_icon {
      position: absolute;
      right: -1px;
      bottom: -1px;
      width: 20px;
      display: none;
    }
  }
}

.tips_desc_title {
  //font-size: 14px;
  font-size: 0.75rem;
  color: #ccc;
  text-align: center;
  padding: 20px 0;

  &:before,
  &:after {
    content: "";
    display: inline-block;
    width: 75.5px;
    height: 1px;
    vertical-align: middle;
    position: relative;
    top: -2px;
  }

  &:before {
    background: url("./img/img_icon_76.png") no-repeat;
    background-size: cover;
    margin-right: 5px;
  }

  &:after {
    background: url("./img/img_icon_77.png") no-repeat;
    background-size: cover;
    margin-left: 5px;
  }
}

.vip_desc_qy {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  color: black;

  p {
    flex: 100%;
    padding: 7px 10px 7px 25px;
    //font-size: 13px;
    font-size: 0.625rem;
    background: url("./img/img_icon_36.png") no-repeat left 7px;
    background-size: 18px 18px;
  }
}

.pj_list {
  margin-top: -10px;

  .pj_item {
    padding: 20px 0;
    border-bottom: 1px dashed #ddd;

    .user {
      display: flex;
      justify-content: space-between;

      .info {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .avatar {
          width: 35px;
          height: 35px;
          border-radius: 50%;
          margin-right: 10px;
        }

        .name {
          .username {
            //font-size: 15px;
            font-size: 0.75rem;
            color: #666;

            .icon_vip {
              display: inline;
              vertical-align: middle;
              margin-top: -4px;
              margin-left: 3px;
            }
          }

          .address {
            //font-size: 14px;
            font-size: 0.75rem;
            color: #999;
            margin-top: 3px;
          }
        }
      }

      .star {
        img {
          width: 12px;
          height: 12px;
        }
      }
    }

    .pj_text {
      margin-top: 10px;
      color: black;
      font-size: 0.75rem;
    }
  }
}

:deep(.centerPanel) {
  overflow: visible;
}

@media (max-width: 400px) {
  .coupon_panel {
    width: 310px !important;
  }
}

@media (min-width: 401px) and (max-width: 499px) {
  .coupon_panel {
    width: 350px !important;
  }

  .line_left {
    width: 90px !important;
  }
}

.payClosePop {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, .5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99;
  font-size: 12px;

  .youhuiBg {
    position: absolute;
    left: 0;
    top: 0;
    // transform: translate(-50%,-50%);
    z-index: 1;
    background: url('./images/payImg/youhuiBg.png') no-repeat;
    width: 500px;
    height: 500px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    animation: spin 2s linear infinite;
  }

  @keyframes spin {
    from {
      transform: translate(-50%, -50%) rotate(30deg);
      transform-origin: center;
    }

    to {
      transform: translate(-50%, -50%) rotate(360deg);
      transform-origin: center;
    }
  }

  .payFirBox,
  .paySecBox {
    position: relative;
    z-index: 2;

    animation: slide-fwd-center 0.45s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;

    .originBaoN {
      position: absolute;
      left: 42px;
      top: 121px;
      display: flex;
      align-items: baseline;
      color: #e22222;
      font-size: 32px;
      z-index: 99;

      .RMBIcon {
        font-size: 20px;
      }
    }

    .getYouBtn {
      width: 175px;
      height: 45px;
      // background: rgba(255,255,255,0.5);
      position: absolute;
      bottom: 68px;
      left: 49%;
      transform: translateX(-50%);
      display: flex;
      align-items: center;
      // text-align: center;
      justify-content: center;
      cursor: pointer;
      color: #000;
      font-weight: 600;
      font-size: 16px;

      .canrenPayBox {
        font-weight: 500;

        .closePayPop {
          width: 16px;
          height: 16px;
          border-radius: 50%;
          background: #ccc;
          margin-right: 10px;
          color: #000;
          font-size: 12px;
          display: flex;
          line-height: 18px;
          font-weight: 500;
          // align-items: center;
          justify-content: center;
        }

        position: absolute;
        bottom: -110px;
        color: #999;
        left: 50%;
        transform: translateX(-50%);
        z-index: 3;
        width: 100%;
        height: 45px;
        background: #fff;
        white-space: nowrap;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 45px;
      }
    }

    .secYouhTim {
      // background: #ccc;
      position: absolute;
      bottom: 28px;
      left: 50%;
      transform: translateX(-50%);
      color: #000;
      white-space: nowrap;

      .youTimBox {
        display: flex;
        align-items: center;
        font-size: 12px;
        margin-right: 10px;
        margin-top: 10px;

        .timBItem {
          background: rgba(255, 255, 255, .3);
          font-size: 13px;
          padding: 0 2px;
          margin: 0 5px;
          border-radius: 3px;
          line-height: 16px;

        }
      }
    }

    .payTextTip {
      position: absolute;
      left: 10%;
      top: 55px;
      // background: #000;
      color: #785c48;

      .readOth {
        color: #e84c2a;
      }
    }

    .payYouDetBox {
      width: 220px;
      // height: 100px;
      // background: rgba(255,255,255,0.8);
      position: absolute;
      left: 49%;
      top: 60px;
      transform: translateX(-50%);
      text-align: center;

      .youTit {
        font-size: 20px;
        color: #e22222;
        font-weight: 600;
      }

      .youTitip {
        margin: 20px 0;
        color: #000;
      }

      .youTitMoBox {
        display: flex;
        align-items: baseline;
        justify-content: center;
        position: relative;

        .youTitNum {
          font-size: 56px;
          font-weight: 800;
          margin: 0 15px;
          color: #e22222;

          .TitNumheight {
            position: absolute;
            right: 35px;
            top: -9px;
            background: #e24c38;
            color: #fff;
            font-size: 14px;
            width: 40px;
            height: 22px;
            border-top-left-radius: 22px;
            border-bottom-right-radius: 22px;
            border-top-right-radius: 22px;
          }
        }

        .youTitRmb {
          font-size: 20px;
          font-weight: 600;
          color: #e22222;
        }
      }

    }

  }

  .paySecBox {
    .payYouDetBox {
      width: 50px;
      height: 50px;
      // background: #ccc;
      left: 57%;
      top: 102px;
      transform: translateX(50%);
      display: flex;
      align-items: center;
      justify-content: center;

      .secYouNum {
        font-size: 30px;
        color: #e73b2a;
        position: relative;
        display: flex;
        align-items: baseline;
        margin-left: -15px;

        .RMBIcon {
          font-size: 20px;
        }

        .youheight {
          position: absolute;
          right: -12px;
          top: -24px;
          background: #e24c38;
          color: #fff;
          font-size: 14px;
          width: 40px;
          height: 22px;
          border-top-left-radius: 22px;
          border-bottom-right-radius: 22px;
          border-top-right-radius: 22px;
        }
      }
    }

    .getYouBtn {
      width: 234px;
      height: 45px;
      // background: rgba(255,255,255,0.5);
      position: absolute;
      bottom: 58px;
      left: 50%;
      transform: translateX(-50%);
      color: #fff;
      font-weight: 500;
    }

    .secYhImg {
      // width: 320px;
      width: 280px;
    }

    .youhuiBg2 {
      position: absolute;
      left: -20px;
      top: -120px;
      width: 110%;
      height: 150px;
      z-index: 1;
      background: url('./images/payImg/youhuiyh.gif') no-repeat;
      background-size: cover;
      // background: #000;
    }
  }

  @keyframes slide-fwd-center {
    0% {
      transform: scale(0);
    }

    100% {
      transform: scale(1);
    }
  }
}

.payClosePopShou {
  background: rgba(0, 0, 0, 0);
  -webkit-animation: slide-bck-br 1s cubic-bezier(0.470, 0.000, 0.745, 0.715) both;
  animation: slide-bck-br 1s cubic-bezier(0.470, 0.000, 0.745, 0.715) both;
}

.payClosePopShou1 {
  background: rgba(0, 0, 0, 0);
  -webkit-animation: slide-bck-br1 1s cubic-bezier(0.470, 0.000, 0.745, 0.715) both;
  animation: slide-bck-br1 1s cubic-bezier(0.470, 0.000, 0.745, 0.715) both;
}

@keyframes slide-bck-br1 {
  0% {
    -webkit-transform: translateZ(0) translateY(0) translateX(0);
    transform: translateZ(0) translateY(0) translateX(0);
  }

  100% {
    -webkit-transform: translateZ(100px) translateY(200px) translateX(200px) scale(0);
    transform: translateZ(100px) translateY(200px) translateX(200px) scale(0);
  }
}

@keyframes slide-bck-br {
  0% {
    -webkit-transform: translateZ(0) translateY(0) translateX(0);
    transform: translateZ(0) translateY(0) translateX(0);
  }

  100% {
    -webkit-transform: translateZ(100px) translateY(200px) translateX(300px) scale(0);
    transform: translateZ(100px) translateY(200px) translateX(300px) scale(0);
  }
}
</style>